module.exports = __webpack_public_path__ + "static/img/1.fa1059d2.gif";